<template>
  <div id="loader-outer">
    <ring-loader :size="'150px'"></ring-loader>
    <div class="loading-text">
      <h2>{{ title }}</h2>
      <span style="margin-top:33px;">
        <pulse-loader :size="'10px'"></pulse-loader>
      </span>
    </div>
  </div>
</template>
<script>
  import RingLoader from './RingLoader.vue'
  import PulseLoader from './PulseLoader.vue'
  export default {
    name: 'Loader',
    props: {
      title: {
        required: false,
        default: 'Loading'
      }
    },
    components: {
      PulseLoader,
      RingLoader
    }
  }
</script>
<style>
  #loader-outer {
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
  }
  .loading-text {
    display: flex;
    font-weight: bold;
    color: rgb(93, 197, 150);
  }
</style>



// WEBPACK FOOTER //
// Loader.vue?58a3ef26